export default [
    {
        name: 'querySaleNetLists',
        url: '/lists'
    },
    {
        name: 'addSaleNet',
        url: '/add'
    },
    {
        name: 'updateSaleNet',
        url: '/update'
    },
    {
        name: 'updateSaleNetStatus',
        url: '/update_status'
    },
    {
        name: 'fetchSaleNet',
        url: '/detail'
    },
    {
        name: 'deleteSaleNet',
        url: '/delete'
    }
];
